import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

const sidebarURL = `${environment.api}/sidebar/`;

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  sectionsStatus$ = new BehaviorSubject<{ [key: string]: boolean }>({});

  constructor(private readonly http: HttpClient) {}

  /**
   * chiamata api per recuperare tutte le sezioni e aggiornare lo stato
   */
  loadSections(): Observable<any> {
    return this.http.get<any>(sidebarURL + 'index').pipe(
      tap(res => {
        this.sectionsStatus$.next(res.Sections);
      })
    );
  }

  getSectionsStatus(): Observable<{ [key: string]: boolean }> {
    if (Object.keys(this.sectionsStatus$.value).length === 0) {
      this.loadSections().subscribe(); // esegue il fetch e aggiorna lo stream
    }

    return this.sectionsStatus$.asObservable();
  }

  /**
   * espone lo stato delle sezioni come Observable per essere sottoscritto
   */
  getSectionsStatus$(): Observable<{ [key: string]: boolean }> {
    return this.sectionsStatus$.asObservable();
  }

  /**
   * funzione per controllare se una sezione è abilitata (usa lo stato corrente)
   */
  isSectionEnabled(section: string): boolean {
    return this.sectionsStatus$.value[section];
  }

  toggleSection(section: string, enabled: boolean) {
    const obj = { alias: section, is_visible: enabled };
    return this.http.post<any>(sidebarURL + 'updateVisibility', obj);
  }
}
